import Template from 'backbone/story/templates/comments/comment_form.js.hamlc'
import Comment from 'backbone/story/models/comment.js'
import InlineCommentUtils from 'utils/story/inline_comment_utils.js'
import CommentUtils from 'utils/story/comment_utils.js'
import BackboneDispatcher from 'lib/backbone_dispatcher.js'

export default class CommentFormView extends Backbone.View
  events:
    "submit form.new-comment"       : "onFormSubmit"
    "click .js-cancel"              : "onCancelNewComment"
    "click"                         : "stopPropagation"

  initialize: (options) ->
    @options = options
    @markId = options.markId
    @inline = options.inline || false
    @video = options.video || false
    @image = options.image || false
    @targeted = @inline || @video || @image
    @inlineCommentUtils = new InlineCommentUtils()
    @commentCollection = page.get("storyComments")
    @dispatcher = BackboneDispatcher.get_instance()
    @commentViewMediator = page.get("commentViewMediator")
    $("body").on("click", @removeIfEmptyTargetedComment)
    @render()
    @$commentBodyField = @$('textarea[name="comment[body]"]')

  remove: =>
    $("body").unbind("click", @removeIfEmptyTargetedComment)
    super()

  removeIfEmptyTargetedComment: (e) =>
    return unless @targeted
    return if CommentUtils.isTextCompleteClick(e)
    return if @commentViewMediator.commentInProgress()

    @remove()

  onFormSubmit: (e) ->
    e.preventDefault()
    @$form = $(e.target)
    contently.ui.disable_button_with_spinner(@$form.find(":submit"))
    @$commentBodyField = @$form.find('textarea[name="comment[body]"]')
    @saveNewComment()

  saveNewComment: ->
    comment = @buildComment()
    comment.save({ token: window.story.remote_token }, {
      success: @onCommentCreated
      error: @onCommentSaveError
    })

    if comment.validationError
      contently.flash.alert comment.validationError
      contently.ui.enable_button @$form.find(":submit")
    else
      @_maskForm()
      $("body").find(".actions-other").addClass("allow-comment") if @inline
      $(".panel-content-wrapper").removeClass("hide-comments")

  _maskForm: ->
    @$("form").maskLoading()

  _unmaskForm: ->
    @$("form").unmaskLoading()

  _saveCompleteCallbacks: ->
    contently.ui.enable_button @$el.find("button")
    CommentUtils.initCommentMentioning(@$el.find('#comment_body'))
    @_unmaskForm()
    # remove any autosizing from textarea
    @$commentBodyField[0].style.removeProperty("height")

  onCommentCreated: (comment) =>
    @_saveCompleteCallbacks()

    if @targeted
      if @inline && comment.get("mark_id") == null # Comment was inline but could not be anchored
        errorMessage = "We couldn't anchor your comment to the highlighted text, " +
        "but it was saved in the comments tab."
        contently.flash.alert(errorMessage)
        @commentCollection.add(comment)
        @remove()
        @dispatcher.trigger("commentCreated")
      else
        @inlineCommentUtils.removeMarkProvisionaryDesignation(@markId)
        @$commentBodyField.val("")
        @commentCollection.add(comment)
        @remove()
    else
      @$commentBodyField.val("")
      @commentCollection.add(comment)
      @dispatcher.trigger("commentCreated")
    @commentCollection.setActive(comment)

  onCommentSaveError: (comment, response, options) =>
    @_saveCompleteCallbacks()

    if response.status == 403
      return window.location = "/signin"
    else if response.status == 422 && window.story.remote
      msg = "There was a problem saving your comment. The content may have changed recently. Please try refreshing the page."
      contently.flash.alert(msg)
    else
      contently.flash.alert("There was a problem saving your comment.")

  onCancelNewComment: =>
    @options.onDestroy() if @options.onDestroy?
    if @targeted
      @commentViewMediator.removeCommentForm()
    else
      @remove()

  buildComment: ->
    now = moment().format()
    new Comment(
      story_id: window.story.id,
      parent_id: @$form.find('input[name="comment[parent_id]"]').val(),
      body: @$commentBodyField.val(),
      highlighted_text: @options.highlightedText,
      provisional_marks: @options.provisionalMarks,
      authorable_avatar_url: contently.ui.current_user.avatar_url,
      authorable_name: contently.ui.current_user.name,
      can_be_updated: true,
      can_be_resolved: true,
      mark_id: @markId,
      read: true,
      thread_read: true,
      created_at: now,
      created_at_friendly: "Just now",
      thread_updated_at: now,
      text_model_type: @options.text_model_type,
      text_model_id: @options.text_model_id,
      text_model_attribute: @options.text_model_attribute,
      start_time: @options.startTime,
      end_time: @options.endTime,
      shape: @options.shape,
      asset_id: @options.assetId
    )

  render: ->
    @$el.html(Template(@options))
    contently.ui.autosizeTextarea(@$("#comment_body"))
    CommentUtils.initCommentMentioning(@$("#comment_body"))
    @$(".new-comment textarea").focus()

  stopPropagation: (e) -> e.stopPropagation()



// WEBPACK FOOTER //
// ./app/javascript/backbone/story/views/comments/comment_form_view.js.coffee